
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import reportMsgUt from "@/util/reportMsg";
    import {useRoute, useRouter} from "vue-router";
    import { Popup } from 'scvant';
    import circleCom from './circleCom.vue'
    import utils from '@/util/index';

    interface State {
        point: ComputedRef<"N" | "Y">; // N 没有三种缺陷 Y 有三种缺陷
        isAccident: number; // 0不是事故车 1是事故车
        isFire: number; // 0不是事故车 1是事故车
        isWater: number; // 0不是事故车 1是事故车
        reportCode: string | null;
        channelType: string;
        logoUrl: string;
        protectTime: string;
        promiseMsg: string;
        reportMsg: object;
        templateCode: string;
        brandName: string;
        seriesName: string;
        modelName: string;
        vin: string;
        reportGenDate: string;
        showProtect: boolean;
        isXNY: boolean;
        isSF: any;
        productName: string;
        accidentFlag: number;// 0 非事故车 1 非重大事故 2 重大事故车
        showPromiseDes: string;
        rankDesc: any;
        rank: string | null;
        brandLogo: string;
        reportFreeCheckVersion: any;
        orderDate: string;
        version240530: any;
        version240702: any;
        version240704: any;
        blueCircleList: Array<object>;
        blueCircleWidth: number;
        blueCircle: object;
    }

    export default defineComponent({
        name: "headTip",
        setup() {
            const {query} = useRoute();
            let state: State = reactive({
                point: "Y" as any,
                isAccident: 1,
                isFire: 1,
                isWater: 1,
                reportCode: '',
                channelType: `${query.channelType}` || '',
                logoUrl: '',
                protectTime: '90',
                promiseMsg: '268V专注检测20年，验车况，有保障',
                reportMsg: {},
                templateCode: '',
                brandName: '',
                seriesName: '',
                modelName: '',
                vin: '',
                reportGenDate: '',
                showProtect: false,
                isXNY: false,
                isSF: -1,
                productName: `${query.productName || ''}`,
                accidentFlag: 2,
                showPromiseDes: '',
                rankDesc: null,
                rank: null,
                brandLogo: '',
                reportFreeCheckVersion: null,
                orderDate: '',
                version240530: 0,
                version240702: 0,
                version240704: 0,
                 blueCircleWidth: 8,
                 blueCircle: {
                    name: 'checkModule', 
                    value: 'linear-gradient(90deg, #007DF3 0%, #0F3299 100%)',
                    id: 'gradient-checkModule',
                    backgroundColor: '#C2DFF5',
                    color1: '#007DF3',
                    color2: '#0F3299',
                },
                blueCircleList: [{
                    name: 'appearanceCircle',
                    total: 0,
                    error: 0,
                    nameTxt: '外观检测',
                    clickToId: 'Appearance',
                },{
                    name: 'interiorCircle',
                    total: 0,
                    error: 0,
                    nameTxt: '内饰检测',
                    clickToId: 'Interior',
                },{
                    name: 'lightingCircle',
                    total: 0,
                    error: 0,
                    nameTxt: '灯光及电器',
                    clickToId: 'Lighting',
                },{
                    name: 'bottomCircle',
                    total: 0,
                    error: 0,
                    nameTxt: '底盘检测',
                    clickToId: 'Bottom',
                },{
                    name: 'startUpCircle',
                    total: 0,
                    error: 0,
                    nameTxt: '启动检测',
                    clickToId: 'StartUp',
                }],
            })
            // 格式化时间
            function formatDate(dateTime) {
                if(!dateTime) {
                    return 0;
                }
                let reg1 = /[- :]/g;
                let dateNum = Number(dateTime.replace(reg1, ''));
                return dateNum
            }
            state.reportMsg = reportMsgUt;
            state.reportCode = `${query.reportCode}`;
            state.templateCode = `${query.templateCode}`;
            state.protectTime = state.channelType === 'jiaxuan' ? '100' : '90';
            // 获取路由器实例
            const router = useRouter()
            let store = useStore();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo);
            let isNormal: ComputedRef<{}> = computed<{}>(() => store.state.isNormal);
            let reportResultList: ComputedRef<{}> = computed<{}>(() => store.state.reportResultList);
            state.isSF = computed(() => {
                return store.state.isNormal
            });
            state.point = computed(() => {
                return store.state.isNormal ? 'N' : 'Y'
            })
            state.version240530 = computed(() => {
                return store.state.version240530 || 0
            })
            state.version240702 = computed(() => {
                return store.state.version240702 || 0
            })
            state.version240704 = computed(() => {
                return store.state.version240704 || 0
            })

            console.log('reportResultList:', reportResultList);
            watch(dataInfo, (data: any) => {
                const {
                        isAccident, 
                        isFire, 
                        isWater, 
                        reportConfigInfo, 
                        brandName, 
                        seriesName,
                        modelName, 
                        vin, 
                        reportDetectOrderVO, 
                        energyType,
                        productName,
                        accidentFlag, 
                        rankDesc, 
                        rank,
                        brandLogo,
                        reportFreeCheckVersion,
                        orderDate,
                        checkModules
                    } = data;
                state.logoUrl = reportConfigInfo ? reportConfigInfo.logoUrl : '';
                state.isAccident = accidentFlag > -1 ?  accidentFlag : isAccident ;
                state.isFire = isFire
                state.isWater = isWater
                state.brandName = brandName
                state.seriesName = seriesName
                state.modelName = modelName
                state.vin = vin;
                state.reportGenDate = reportDetectOrderVO.reportGenDate
                state.isXNY = energyType === 2 ? true : false;
                state.rankDesc = rankDesc;
                state.rank = rank;
                state.brandLogo =  utils.replaceImageUrl(brandLogo);
                state.reportFreeCheckVersion = reportFreeCheckVersion || 0;
                state.orderDate = orderDate || '';
                // 更新blueCircleList中的数据
                if (checkModules && Array.isArray(checkModules)) {
                    state.blueCircleList.forEach((item: any) => {
                        const matchedModule = checkModules.find((module: any) => module.code === item.clickToId);
                        if (matchedModule) {
                            item.total = matchedModule.checkCount ;
                            item.error = matchedModule.defectCount ;
                        }
                    });
                }

                // console.log(productName);
                // console.log(accidentFlag);
                //第一版新版报告上线静态化中没有productName字段并且上线的是299相关报告，解析完为undefined,用事故排查检测
                if (!state.productName) {
                    state.productName = productName === undefined ? '事故排查检测' : (productName === null ? '' :productName); 
                }
                state.accidentFlag = accidentFlag;
  
            })
            function getToCV3RectangleStyle(): object  {
                let rectangleStyle = {};
                 rectangleStyle = {'tocV3_rectangle_orange': state.isSF, 'tocV3_rectangle_white': !state.isSF};
                return rectangleStyle;
            }
            function getHeadPromiseBgStyle(): object {
                let promiseStyle = {};
                promiseStyle = {'head_promise_bg_699': true};
                return promiseStyle;
            }
            function getHeadResultBgStyle(): object  {
                let resultBgStyle = {};
                // if (state.reportMsg['Rp499']()) {
                //     resultBgStyle = {'head_result_bg_499': true,'result_bg_nosf': !state.isSF};
                // } else if (state.reportMsg['Rp699']()) {
                //     resultBgStyle = {'head_result_bg_699': true, 'result_bg_nosf': !state.isSF};
                // } else {
                //     resultBgStyle = {'head_result_bg_nomal': true, 'result_bg_nosf': !state.isSF};
                // }
                resultBgStyle = {'head_result_sf_bg': true};
                return resultBgStyle;
            }
            function getToCV3RectangleLineStyle(): object  {
                let rectangleLineStyle = {};
                 rectangleLineStyle = {'tocV3_rectangle_orange_line': state.isSF, 'tocV3_rectangle_white_line': !state.isSF};
                return rectangleLineStyle;
            }
            function getToCV3RectangleWhiteLineStyle(): object  {
                let rectangleWhiteLineStyle = {};
                rectangleWhiteLineStyle = {'tocV3_rectangle_orange_white_line': state.isSF, 'tocV3_rectangle_white_white_line': !state.isSF};
                return rectangleWhiteLineStyle;
            }
            function getAccidentDes(): string  {
                let accidentDes = '';
                if (state.accidentFlag === undefined) {//走旧的逻辑
                    accidentDes = !state.isAccident ? '非事故车' : '事故车';
                } else {//根据accidentFlag判断
                    if (state.accidentFlag  === 0) {
                        accidentDes = '非事故车';
                    }  else if (state.accidentFlag  === 1) {
                         accidentDes = '事故车';
                    }  else if (state.accidentFlag  === 2) {
                        accidentDes = '重大事故车';
                    }
                }
                return accidentDes;
            }
            function getToCV3RectangleProtectBorderStyle(): object  {
                let protectBorderStyle = {};
                protectBorderStyle = {'tocV3_rectangle_protect_border_orange': true};
                return protectBorderStyle;
            }
            function getWenLiPic() {
                let wenLiPic = null;
                wenLiPic = require("../../../assets/tocV3/toCV3RectangleWenLiOrange.png");
                return wenLiPic;
            }
            function getVectorIcon() {
                let vectorIcon = require("../../../assets/tocV4/headVector.png");
                return vectorIcon;
            }
            function getRightArrowIcon() {
                let arrowIcon = require("../../../assets/tocV4/headArrowRight.png");
                return arrowIcon;
            }
            function getPromiseMsgFont(): object  {
                let fontStyle = {};
                 fontStyle = {'head_promise_font_699': true};
                return fontStyle;
            }
            //获取等级标签图标
            function getResBoxLevelIcon() {
                let levelIcon = null;
                if (state.rank === 'S') {
                    levelIcon = require("../../../assets/tocV4/S_299.png");
                } else if (state.rank === 'C'){
                    levelIcon = require("../../../assets/tocV4/C_299.png");
                } else if (state.rank === 'D'){
                    levelIcon = require("../../../assets/tocV4/D_299.png");
                }
                return levelIcon;
            }
            function getResJiStyleIcon() {
                let jiIcon = require("../../../assets/tocV4/ji_299.png");
                return jiIcon;
            }
            // function getResBoxItemTxtWrapStyle() {
            //     let txtWrapStyle = {'resBox_item_txt_wrap_299': true};
            //     return txtWrapStyle;
            // }
            function getElementToPageTop (el) {
                if (el.offsetParent) {
                    return getElementToPageTop(el.offsetParent) + el.offsetTop
                }
                else {
                    return el.offsetTop
                }
            }
            return {
                state,
                router,
                dataInfo,
                isNormal,
                reportResultList,
                getToCV3RectangleStyle,
                getToCV3RectangleLineStyle,
                getToCV3RectangleWhiteLineStyle,
                getAccidentDes,
                getToCV3RectangleProtectBorderStyle,
                getWenLiPic,
                getHeadPromiseBgStyle,
                getHeadResultBgStyle,
                getVectorIcon,
                getRightArrowIcon,
                getResBoxLevelIcon,
                getResJiStyleIcon,
                getPromiseMsgFont,
                formatDate,
                getElementToPageTop
            }
        },
        components: {
            [Popup.name]: Popup,
            circleCom,
        },
        methods: {
            setProgress(item) {
                if (item.type === 'normal') {
                    return item.normal / item.total * 100;
                }
                return 100 - (item.error / item.total * 100);
            },
            clickTab(id) { // 点击tab切换
                const sTop = document.documentElement.scrollTop || document.body.scrollTop;
                const eTopEl: any = document.getElementById(id);
                const topNum = this.getElementToPageTop(eTopEl);
                console.log('id---', id, 'sTop---', sTop, 'topNum---', topNum, 'eTopEl---', eTopEl);
                utils.scrollTop(window, sTop, topNum - 60, 500);
            },
            toExplain(desc) {
                if (desc === 'auth') {
                    this.router.push({
                        path: '/tocT9explainFreeAuth',
                        query: {
                            templateCode: this.state.templateCode,
                            reportFreeCheckVersion: this.state.reportFreeCheckVersion
                        }
                    })
                } else {
                    this.router.push({
                        path: '/tocT9ExplainFreeCheck',
                        query: {
                            channelType: this.state.channelType,
                            templateCode: this.state.templateCode,
                            reportFreeCheckVersion: this.state.reportFreeCheckVersion,
                            orderDate: this.formatDate(this.state.orderDate)
                        }
                    })
                }
            },
            setShowProtect(){
                let lbParam = {
                    templateCode: this.state.templateCode
                }
                this.state.showProtect = !this.state.showProtect;
            },
        }
    })
